'use client';

import Link from 'next/link';

import { ErrorBlock } from './ErrorBlock';

export default function NotAllowedCountry() {
  return (
    <ErrorBlock
      logo={true}
      image="/oopsImg.webp"
      richText={
        <>
          <h3>Players from your country are not allowed to visit this site</h3>
          <h4>Not in a restricted country?</h4>
          <p>
            if you are using a proxy service or VPN to access{' '}
            <Link href="https://levelupcasino.com/">levelupcasino.com,</Link>{' '}
            try turning it off and reload the page.
          </p>
        </>
      }
    />
  );
}
